export default "__VITE_ASSET__xkPNnUJn__"